import api from "./client";
import type { ApiResponse } from "#/types/api";
import type {
  FeedbackSummary,
  PredictionBoard,
  PredictionComputeSummary,
  PredictionFeedbackPayload,
  ShipmentDetail,
  ShipmentSummary,
} from "#/types/prediction";

/**
 * Logistics Prediction. Client users read their own client; a TMA admin
 * passes `clientId`. Settings live on the client record (`clientsApi.update`).
 */
export const predictionApi = {
  /**
   * The calendar. With `range` (the week on screen) every shipment dated in it,
   * past ones included; without, today onwards.
   */
  getBoard: (
    clientId?: number,
    range?: { from: Date; to: Date }
  ): Promise<ApiResponse<PredictionBoard>> =>
    api.get("/predicted-deliveries", {
      params: {
        ...(clientId ? { clientId } : {}),
        ...(range ? { from: range.from.toISOString(), to: range.to.toISOString() } : {}),
      },
    }),

  getShipment: (id: number): Promise<ApiResponse<ShipmentDetail>> =>
    api.get(`/predicted-deliveries/shipments/${id}`),

  /** Thumbs up / down on one shipment. */
  giveFeedback: (
    shipmentId: number,
    payload: PredictionFeedbackPayload
  ): Promise<ApiResponse<ShipmentSummary>> =>
    api.post(`/predicted-deliveries/shipments/${shipmentId}/feedback`, payload),

  /** TMA admin: recompute the client's predictions now. */
  compute: (clientId: number): Promise<ApiResponse<PredictionComputeSummary>> =>
    api.post(`/prediction/clients/${clientId}/compute`, {}),

  /** TMA admin: thumbs up / down totals and reasons. */
  feedbackSummary: (clientId: number): Promise<ApiResponse<FeedbackSummary>> =>
    api.get(`/prediction/clients/${clientId}/feedback-summary`),
};
